
import FormGroup from "./FormGroup"
import {useState, useEffect} from 'react';

const TextField = (props) => {
    const [data, setData] = useState(props.value || "");
    const onChange = (e) => {
        setData(e.target.value);
        props.onChange(props.id, e.target.value);
    }

    useEffect(() => {
        setData(props.value || "");
    }, [props.value]);

    useEffect(() => {
        if(props.onLoad) {
            props.onLoad();
        }
    }, []); // Only run once on mount
  
    return (
        <FormGroup {...props}>
            <input required={props.required} className="form-control"
                type={props.type||"text"}
                name={props.id}
                onChange={onChange}
                value={data}
                step={props.step||"any"}
                disabled={props.disabled}
            />
        </FormGroup>
    )
}

export default TextField;